@if(showingAlert() | async; as alert){
<app-alert
  [message]="alert.message"
  [alertType]="alert.type"
  [dismissable]="alert.dismissible"
  (dismiss)="onAlertDimissed()"
/>
} @if(authService.isLoggedIn()){
<div class="main-layout d-flex" [class.sidebar-open]="!(isCollapsable() | async)">
  <app-side-bar-menu />
  <div class="content-area flex-grow-1">
    <router-outlet />
  </div>
</div>

}@else {
<router-outlet />
}
